module.exports = __webpack_public_path__ + "static/media/userPic.a04fdc1c.png";